<template>
  <section class="py-5">
    <div class="container">
      <div class="row">
        <!-- Foto Slider (Kiri) -->
        <div class="col-md-8">
          <SliderPart/>
        </div>

        <!-- Daftar Berita (Kanan) -->
        <div class="col-md-4">
          <h3>Terpopuler</h3>

          <div v-if="loading">Loading...</div>
          <div v-else-if="error">{{ error }}</div>
          <div v-else class="news-list">
            <ul class="list-group">
              <div v-for="news in newsList" :key="news.id" class="news-item">
                <li class="list-group-item">
                  <router-link
                    :to="`/berita/${news.id}`"
                    class="text-decoration-none text-success"
                    ><strong>{{ news.judul }}</strong> <br />{{
                      news.short_description
                    }}</router-link
                  >
                </li>
                <!-- <img :src="news.image" alt="news.title" class="news-image" />
              <h3>{{ news.title }}</h3>
              <p>{{ news.content }}</p>
              <span>{{ formatDate(news.date_published) }}</span> -->
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

import SliderPart from "./SliderPart.vue";
export default {
  name: "ContentSection",
  components: {
      SliderPart,
    },
  data() {
    
    return {
      newsList: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get("https://mui-kendal.or.id/pengurus/Api/latestNews");
        this.newsList = response.data.Data;
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti ya.";
      } finally {
        this.loading = false;
      }
    },
    
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};
</script>

<style>
.carousel {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.list-group-item {
  border: none;
  padding: 15px;
}

.list-group-item a {
  color: #333;
}

.list-group-item a:hover {
  text-decoration: underline;
}
</style>
